import PropTypes from 'prop-types';
import React from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
	Image,
	Usernames,
	Text,
	Preview,
	Footer
} from './components'

import { seenNotification, getNewNotifications } from '~/actions/notifications'


class Item extends React.Component {
    static propTypes = {
		action: PropTypes.string,
		activity: PropTypes.string,
		created_date: PropTypes.string,
		dispatch: PropTypes.func,
		ID: PropTypes.string,
		link: PropTypes.string,
		resource: PropTypes.object,
		seen: PropTypes.bool,
		seen_date: PropTypes.string,
		thisUser: PropTypes.object,
		users_involved: PropTypes.array
	};

    seeNotification = () => {
		if( !this.props.seen ) this.props.seenNotification(this.props.ID)
		if( this.props.link ) this.props.match.push(this.props.link);
	};

    render() {

		return (

			<li className={"notification-item clickable " + (this.props.seen ? 'seen' : 'un-seen')} onClick={this.seeNotification}>
				<div className="narrow-gutter pleft10 pright10 ptop5 pbot5">
					<div className="row">
						<div className="col-xs-2">
							<Image users={this.props.users_involved} myProfilePicture={this.props.thisUser.profile_picture} />
						</div>
						<div className="col-xs-10">
							<p>
								<Usernames users={this.props.users_involved} thisUserID={this.props.thisUser.ID} /> <Text action={this.props.action} activity={this.props.activity} resource={this.props.resource} /> <Preview resource={this.props.resource} />
							</p>
							<Footer created_date={this.props.created_date} resource={this.props.resource} seen={this.props.seen} seeNotification={this.seeNotification} />
						</div>
					</div>
					
				</div>
				<hr className="m0"/>
			</li>

		)
	}
}

const mapStateToProps = state => ({
    thisUser: state.session.user
});

const mapDispatchToProps = dispatch => bindActionCreators({ seenNotification }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( withRouter(Item) );




// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/index.js